<template>
  <BaseEdit
    @edit-confirm-action="updateEntry"
    @edit-cancel-action="resetForm"
    @edit-open-action="loadServerEntry(entry)"
    @clear-form-errors="clearFormErrors"
    ref="baseEdit"
    editTitle="Edição de Produto Produzido"
    width="70%"
    :formErrors="formErrors"
    :loading="loading"
    :pageLoading="pageLoading"
    :readOnly="readOnly"
    :modelNameSingular="modelNameSingular"
  >
    <template slot="editForm">
      <Form
        ref="form"
        :entry="editableEntry"
        :extraData="extraData"
        :seedPlotOperation="seedPlotOperation"
        :executionOperation="executionOperation"
        :isEdit="isEdit"
        :originalEntry="originalEntry"
        :readOnly="readOnly"
        :modelNameSingular="modelNameSingular"
      />
    </template>
  </BaseEdit>
</template>

<script>
import gql from 'graphql-tag';
import Form from "./form.vue";
import BaseEdit from "@shared_components/base_edit.vue";

export default {
  data() {
    return {
      error: null,
      loading: true,
      pageLoading: false,
      editableEntry: null,
      formErrors: [],
      extraData: null,
      originalEntry: null,
      editEntry: null,
    };
  },
  props: {
    entry: Object,
    executionOperation: Object,
    seedPlotOperation: Object,
    isEdit: {
      type: Boolean,
      default: false
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
  },
  components: {
    Form: Form,
    BaseEdit: BaseEdit
  },
  methods: {
    created(){
      // console.log("entry", this.entry);
      // console.log("entryOr", this.originalEntry);
    },
    loadServerEntry: function(loadEntry) {
      console.log('laodEntry', loadEntry);
      this.loadEndProduct(loadEntry);
    },
    loadEndProduct: function(loadEntry) {
      this.originalEntry = loadEntry;
      // this.originalEntry = JSON.parse(JSON.stringify(loadEntry));
      console.log("loadEntry", loadEntry);
      console.log("orEntry", this.originalEntry);
      this.editableEntry = JSON.parse(JSON.stringify(loadEntry));
      // this.editableEntry.entryMovementItemLotsAttributes = JSON.parse(JSON.stringify(loadEntry.entryMovementItemLotsAttributes));
      // this.editableEntry = loadEntry;
      // this.editableEntry.entryMovementItemLotsAttributes = [];
      // loadEntry.entryMovementItemLotsAttributes.forEach((item)=>{
      //   this.editableEntry.entryMovementItemLotsAttributes.push(item);
      // });
      // this.editableEntry.entryMovementItemLotsAttributes = _.cloneDeep(loadEntry.entryMovementItemLotsAttributes);
      console.log('editableEntry', this.editableEntry);
      this.error = null;
      this.loading = true;
      if(this.executionOperation){
        console.log("exec");
      this.$apollo
        .query({
          query: LOAD_PRODUCED_PRODUCT_QUERY,
          variables: {
            periodIds: this.executionOperation.periodIdsAttribute
          },
          fetchPolicy: "no-cache"
        })
        .then(response => {
          this.originalEntry.validations = response.data.groundContext.entryProducedProduct.validations;
          this.extraData = response.data;
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));
      }else if(this.seedPlotOperation){
        this.$apollo
          .query({
            query: NEW_SEEDLING_QUERY,
            variables: {
              operationTypeId: this.seedPlotOperation.operationType.id,
            },
            fetchPolicy: "no-cache"
          })
          .then(response => {
            // console.log("itens for produced_product", response);
            this.editableEntry.validations = response.data.groundContext.entrySeedling.validations;
            this.extraData = response.data;
          })
          .catch(response => console.log(response))
          .finally(() => (this.loading = false));
      }
    },
    updateEntry: function() {
      if (this.$refs.form.isFormValid()){
        this.pageLoading = true;
        Object.assign(this.originalEntry, this.editableEntry);
        this.pageLoading = false;
        this.$refs.baseEdit.closeDialog();
        this.$emit("entry-updated", this.editableEntry);
        this.resetForm();
      }
    },
    resetForm: function() {
      if (this.$refs.form) {
        this.$refs.form.resetFormInputs();
      }
      this.formErrors = [];
    },
    clearFormErrors: function() {
      this.formErrors = [];
    }
  }
};

const LOAD_PRODUCED_PRODUCT_QUERY = gql `
  query($periodIds: [ID!]!) {
    groundContext {
      entryProducedProduct {
        validations
      } 
    }
    accountContext{
      availableEndProductsForCroppingInExecutionOperation(periodIds: $periodIds){
        id
        name
        cropLimit
        unit {
          id
          name
        }
        brand {
          id
          name
        }
        group {
          id
          name
        }
      }
      allStorages {
        id
        name
        location
      }
    }
  }
`;

const NEW_SEEDLING_QUERY = gql `
  query($operationTypeId: ID){
    groundContext {
      entrySeedling {
        id
        itemId
        item {
          id
          name
          unit {
            id
            name
          }
        }
        packagingId
        packaging {
          id
          name
          unitName
          size
          text
        }
        quantity
        storageId
        storage {
          id
          name
        }
        validations
      }
    }
    accountContext{
      availableSeedlingsForCroppingInSeedPlotOperation(operationTypeId: $operationTypeId){
        id
        name
        cropLimit
        unit {
          id
          name
        }
        brand {
          id
          name
        }
        group {
          id
          name
        }
      }
      allGreenhouses {
        id
        name
        location
      }
    }
  }
`;
</script>

<style scoped></style>
